'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const theme_Animation = require('../../../theme/Animation.cjs.js');
const theme_Colors = require('../../../theme/Colors.cjs.js');
const theme_Shadows = require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const theme_Zindexes = require('../../../theme/Zindexes.cjs.js');
const hooks_useClickOutside = require('../../../hooks/useClickOutside.cjs.js');
const hooks_useIntersect = require('../../../hooks/useIntersect.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const menuOpenAnimation = react.keyframes({
  "0%": {
    transform: "translateY(-10px)",
    opacity: 0
  },
  // This "delay" gives enough time for the menu to be measured
  // by `useIntersect` and flip upwards if it needs to, without
  // flickering for a moment while it renders down and is measured.
  "30%": {
    transform: "translateY(-10px)",
    opacity: 0
  },
  "100%": {
    transform: "translateY(0)",
    opacity: 1
  }
});
const DISTANCE = "calc(100% + 5px)";
const Styles = styleEncapsulation.labelStyles("FloatingBox", {
  root: (props, derivedState) => [
    react.css(Object.assign(Object.assign({}, styleMixins_reset.boxSizing), { animation: `${theme_Animation.Animation.transitionDuration} ease-out ${menuOpenAnimation}`, maxWidth: props.maxWidth, position: "absolute", minWidth: props.minWidth, zIndex: theme_Zindexes.Zindexes.dropdownMenu })),
    props.align === "left" && styleEncapsulation.withModifier(props.align, {
      left: 0
    }),
    props.align === "right" && styleEncapsulation.withModifier(props.align, {
      right: 0
    }),
    props.align === "stretch" && styleEncapsulation.withModifier(props.align, {
      left: 0,
      right: 0
    }),
    derivedState.position === "south" && styleEncapsulation.withModifier(derivedState.position, {
      top: DISTANCE
    }),
    derivedState.position === "north" && styleEncapsulation.withModifier(derivedState.position, {
      bottom: DISTANCE
    })
  ],
  box: (backgroundColor, borderRadius, borderColor) => react.css(Object.assign(Object.assign({}, styleMixins_reset.boxSizing), { backgroundColor, border: `1px solid ${borderColor}`, borderRadius: `var(--zds-radius-${borderRadius})`, boxShadow: theme_Shadows.Shadows.elevation20 }))
});
function getBackgroundColor(hasWhiteBackground = false) {
  return hasWhiteBackground ? "#fff" : theme_Colors.Colors.BackgroundWeaker;
}
const FloatingBox = ({ children, hasWhiteBackground = void 0, intersectHeight = void 0, maxWidth = void 0, minWidth = void 0, onClickOutside = () => {
}, align = "left", position = void 0, borderRadius = "small", borderColor = theme_Colors.Colors.StrokeWeaker }) => {
  const threshold = 0.9;
  const node = React.useRef(null);
  const [setIntersectNode, { isBottomIntersecting, isTopIntersecting }] = hooks_useIntersect.useIntersect({
    heightOverride: intersectHeight,
    once: true,
    threshold
  });
  const backgroundColor = getBackgroundColor(hasWhiteBackground);
  const [setClickOutsideNode] = hooks_useClickOutside.useClickOutside({
    onClickOutside
  });
  React.useEffect(() => {
    setIntersectNode(node.current);
    setClickOutsideNode(node.current);
  }, [setClickOutsideNode, setIntersectNode]);
  const derivedState = {
    position: position || (isTopIntersecting || !isBottomIntersecting ? "south" : "north")
  };
  return react.jsx(
    "div",
    { css: Styles.root({ maxWidth, minWidth, align }, derivedState), ref: node, "data-testid": "floating-box", "data-zds": true },
    react.jsx("div", { css: Styles.box(backgroundColor, borderRadius, borderColor) }, children)
  );
};

exports.FloatingBox = FloatingBox;
//# sourceMappingURL=FloatingBox.cjs.js.map
